import { useReducer } from 'react'
import { videoCaptureReducer } from '../utilities/videoCaptureReducer'
import { initialState } from '../utilities/initialValues'

export const useModal = () => {
    const [state, dispatch] = useReducer(videoCaptureReducer, initialState)
    const { showModal } = state

    const handlePreviewOpen = () => {
        dispatch({ type: 'SET_SHOW_MODAL', payload: true })
    }

    const handlePreviewClose = () => {
        dispatch({ type: 'SET_SHOW_MODAL', payload: false })
        dispatch({ type: 'SET_VIDEO_SOURCE', payload: null })
    }

    return {
        showModal,
        handlePreviewClose,
        handlePreviewOpen,
    }
}
